export default "__VITE_ASSET__CGWV0$IC__"